var error = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof shell !== "undefined") return resolve();
	__webpack_require__.l("https://nervous-jones-f43a95.netlify.app/remoteEntry.js", function(event) {
		if(typeof shell !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		error.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		error.name = 'ScriptExternalLoadError';
		error.type = errorType;
		error.request = realSrc;
		reject(error);
	}, "shell");
}).then(function() { return shell; });